// Replace names, quotes and photos with real, verifiable customer testimonials.
export const testimonials = [
  {
    name: '[REAL CUSTOMER NAME]',
    country: 'United States',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/4b5feeab-aa57-480a-b221-8e904d2fde0d.jpg',
    quote: '[Real testimonial about finally having a structured reflexology practice routine.]',
  },
  {
    name: '[REAL CUSTOMER NAME]',
    country: 'United Kingdom',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/13952a50-8490-4633-82bc-06df5d7c4c9b.jpg',
    quote: '[Real testimonial about the 21-day structure and daily practice.]',
  },
  {
    name: '[REAL CUSTOMER NAME]',
    country: 'Canada',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/f8df9259-f953-4bd5-9a56-1c4eb35df1fd.jpg',
    quote: '[Real testimonial about the planners, study cards or checklists.]',
  },
  {
    name: '[REAL CUSTOMER NAME]',
    country: 'Australia',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/fbb87d71-93fc-4e5a-880b-c1f2b8e05d71.jpg',
    quote: '[Real testimonial about becoming more consistent with reflexology practice.]',
  },
  {
    name: '[REAL CUSTOMER NAME]',
    country: 'United States',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/9b500bf5-f88d-4e9b-8baa-7955aaa20cc4.jpg',
    quote: '[Real testimonial about the difference between having information and having a system.]',
  },
];
